module.exports = __webpack_public_path__ + "assets/amstd_commercial_zoom_logo-44729d32-pivot.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styl/images/amstd_commercial_zoom_logo.svg
// module id = 1085
// module chunks = 47